import type { ReactNode } from 'react';

type Props = {
	children: ReactNode;
	className?: string;
};

export default function PageTitle({ children, className }: Props) {
	return (
		<h1
			className={`text-6xl leading-16 max-xl:text-5xl max-md:text-4xl max-md:leading-10 font-bold ${className}`}
		>
			{children}
		</h1>
	);
}
